import { IMyHomeState } from '../../types/redux/myHome';

const defaultState: IMyHomeState = {};

export function myHomeReducer(state: IMyHomeState = defaultState) {
  return state;
}
